import { render, staticRenderFns } from "./utwl-org-select.vue?vue&type=template&id=1b96b43d"
import script from "./utwl-org-select.vue?vue&type=script&lang=js"
export * from "./utwl-org-select.vue?vue&type=script&lang=js"
import style0 from "./utwl-org-select.vue?vue&type=style&index=0&id=1b96b43d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports